import React from 'react';
import styled from 'styled-components';
import {IconoirTrash, IconoirEditPencil} from '@ey-xd/motif-icon';
import Icon from '../../../../BaseComponentWrappers/MotifIcon';
import {labels} from '../../../../../../util/utils';
import GrayFade from '../../../../../Common/GrayFade/GrayFade';

export default function IconColumn(params) {
	const {isLoading, setSelectedStEntity, setShowModal, setShowDeleteModal} = params;

	const onEditClick = () => {
		setSelectedStEntity(params.data);
		setShowModal(true);
	};

	const onDeleteClick = () => {
		setSelectedStEntity(params.data);
		setShowDeleteModal(true);
	};

	return (
		<React.Fragment>
			<GrayFade isGrayFade={isLoading}>
				<StyledIconColumn className="StyledIconColumn">
					<section className="edit-icon">
						<Icon title={labels.edit} hoverText={labels.edit} src={IconoirEditPencil} onClick={onEditClick} />
					</section>
					<section className="delete-icon">
						<Icon title={labels.delete} src={IconoirTrash} onClick={onDeleteClick} />
					</section>
				</StyledIconColumn>
			</GrayFade>
		</React.Fragment>
	);
}

const StyledIconColumn = styled.section`
	display: flex;
	align-items: center;
	.edit-icon {
		margin-right: var(--px-12);
	}
	.delete-icon {
		margin-left: var(--px-12);
	}
`;
